import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
/* 设置localstorage */
function _setLocalStorageMap(mapName, map, during) {
  if (arguments.length === 3) {
    map.during = during;
  }
  map.writeTime = Number(new Date());
  var mapStr = JSON.stringify(map);
  localStorage.setItem(mapName, mapStr);
  return 'setLocalStorageMapSuccess';
}
function _setSessionStorageMap(mapName, map) {
  map.writeTime = Number(new Date());
  var mapStr = JSON.stringify(map);
  sessionStorage.setItem(mapName, mapStr);
  return 'setSessionStorageMapSuccess';
}
/* 取localStorage附带取数据时间 */
function _getLocalStorageMap(mapName) {
  var mapStr = localStorage.getItem(mapName);
  var map = JSON.parse(mapStr);
  if (!map.during) {
    return map;
  }
  map.readTime = Number(new Date());
  if (map.readTime - map.writeTime > map.during) {
    return {};
  }
  return map;
}
function _getSessionStorageMap(mapName) {
  var mapStr = sessionStorage.getItem(mapName);
  var map = JSON.parse(mapStr);
  return map;
}
/* 取随机数整数 */
function _RandomNum(Min, Max) {
  var Range = Max - Min;
  var Rand = Math.random();
  var result = 0;
  if (Math.round(Rand * Range) === 0) {
    result = Min + 1;
  } else if (Math.round(Rand * Max) === Max) {
    result = Max - 1;
  } else {
    result = Min + Math.round(Rand * Range) - 1;
  }
  return result;
}
function _replaceAll(str, str1, str2) {
  var list = str.split(str1);
  return list.join(str2);
}
/* 验证汉字 */
function _filterChinses(str) {
  return str.replace(/[^\u4E00-\u9FA5]/g, '');
}
export default {
  setLocalStorageMap: function setLocalStorageMap(mapName, map, during) {
    return _setLocalStorageMap(mapName, map, during);
  },
  getLocalStorageMap: function getLocalStorageMap(mapName) {
    return _getLocalStorageMap(mapName);
  },
  setSessionStorageMap: function setSessionStorageMap(mapName, map) {
    return _setSessionStorageMap(mapName, map);
  },
  getSessionStorageMap: function getSessionStorageMap(mapName) {
    return _getSessionStorageMap(mapName);
  },
  RandomNum: function RandomNum(min, max) {
    return _RandomNum(min, max);
  },
  filterChinses: function filterChinses(str) {
    return _filterChinses(str);
  },
  replaceAll: function replaceAll(str, str1, str2) {
    return _replaceAll(str, str1, str2);
  }
};